import React, { FC } from 'react';
import styles from '../../../styles/B2C/OptionGrid.module.scss';

const NoSearchResults: FC = () => (
  <div className={styles.noResults}>
    <p>No results found. Try a different search.</p>
  </div>
);

export default NoSearchResults;
